import { Toast } from '../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { callAPI } from '../../../services/api.service';

export const forgotPassword = async (
  email: string,
  setEmail: (email: string) => void,
  setLoader: (loading: boolean) => void
) => {
  try {
    setLoader(true);
    const response = await callAPI('user/forgot-password', { email });

    if (response.status === HTTPStatusEnum.OK) {
      setEmail('');
      Toast('Please Check Your Email');
    } else {
      Toast(response.message, true);
    }
  } catch (error) {
    Toast('Unexpected Error Occurred', true);
  } finally {
    setLoader(false);
  }
};

export const resetPassword = async (
  email: string,
  token: string,
  newPassword: string,
  confirmPassword: string,
  setLoader: (loading: boolean) => void,
  navigate: (path: string) => void
) => {
  if (newPassword.length < 8) {
    Toast('Password Must be at least 8 Characters Long', true);
    return;
  }

  if (newPassword !== confirmPassword) {
    Toast('Passwords do not Match', true);
    return;
  }

  try {
    setLoader(true);
    const response = await callAPI('user/reset-password', {
      email,
      token,
      newPassword,
      confirmPassword
    });

    if (response.status === HTTPStatusEnum.OK) {
      Toast('Password Reset Successfully');
      navigate('/');
    } else {
      Toast(response.message, true);
    }
  } catch (error) {
    Toast('Unexpected Error Occurred', true);
  } finally {
    setLoader(false);
  }
};
